// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
function QuickViewTabs$ProgressBar(Props) {
  var className = Props.className;
  var style = Props.style;
  var mediaId = Props.mediaId;
  var index = Props.index;
  var autoplayOpt = Props.autoplay;
  var autoplayPausedOpt = Props.autoplayPaused;
  var progress = Props.progress;
  var progressSpeed = Props.progressSpeed;
  var setProgressRef = Props.setProgressRef;
  var autoplay = autoplayOpt !== undefined ? autoplayOpt : false;
  var autoplayPaused = autoplayPausedOpt !== undefined ? autoplayPausedOpt : false;
  var match = React.useState(function () {
    return progress;
  });
  var setProgress = match[1];
  var progress$1 = match[0];
  var match$1 = React.useState(function () {
    return false;
  });
  var setForceEndTransition = match$1[1];
  var forceEndTransition = match$1[0];
  var setter = React.useCallback(function (value) {
    Curry._1(setProgress, function (param) {
      return value;
    });
  }, [setProgress]);
  React.useEffect(function () {
    if (setProgressRef !== undefined) {
      setProgressRef.current = Belt_Array.concat(setProgressRef.current, [setter]);
    }
    return function (param) {
      if (setProgressRef !== undefined) {
        setProgressRef.current = Belt_Array.keep(setProgressRef.current, function (fn) {
          return fn !== setter;
        });
        return;
      }
    };
  }, [setProgressRef, setter]);
  React.useEffect(function () {
    Curry._1(setForceEndTransition, function (param) {
      return true;
    });
  }, [progressSpeed, mediaId, index]);
  var match$2 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var $$setTimeout = match$2.setTimeout;
  React.useEffect(function () {
    $$setTimeout(function (param) {
      Curry._1(setForceEndTransition, function (param) {
        return false;
      });
    }, 16);
  }, [forceEndTransition]);
  var translateX = autoplay ? progress$1 !== undefined ? progressSpeed !== undefined ? "0%" : String(progress$1 - 100 | 0) + "%" : progressSpeed !== undefined ? "0%" : "-100%" : "0%";
  var translateX$1 = forceEndTransition ? "-100%" : translateX;
  var translateX$2 = autoplayPaused ? "-99%" : translateX$1;
  var transitionDuration = autoplay && progressSpeed !== undefined ? String(progressSpeed) + "ms" : "0ms";
  var classNameMod = autoplay && progressSpeed !== undefined && !forceEndTransition ? "transition-transform ease-linear" : "transition-none duration-0";
  var className$1 = Cn.make([Belt_Option.getWithDefault(className, ""), CSS$Showside.prefix("w-full"), CSS$Showside.prefix(classNameMod)]);
  var progressStyle = {
    transitionDuration: transitionDuration,
    transform: "translate3d(" + translateX$2 + ", 0, 0)"
  };
  var style$1 = style !== undefined ? Object.assign({}, progressStyle, Caml_option.valFromOption(style)) : progressStyle;
  return React.createElement("div", {
    className: className$1,
    style: style$1
  });
}
QuickViewTabs$ProgressBar.displayName = "QuickViewTabs.ProgressBar";
var ProgressBar = {
  make: QuickViewTabs$ProgressBar
};
function QuickViewTabs(Props) {
  var mediaId = Props.mediaId;
  var index = Props.index;
  var total = Props.total;
  var onClick = Props.onClick;
  var alignOpt = Props.align;
  var autoplayOpt = Props.autoplay;
  var autoplayPausedOpt = Props.autoplayPaused;
  var progress = Props.progress;
  var progressSpeed = Props.progressSpeed;
  var setProgressRef = Props.setProgressRef;
  var positionOpt = Props.position;
  var sizeOpt = Props.size;
  var styleOpt = Props.style;
  var enableTruncationOpt = Props.enableTruncation;
  var isMobileOpt = Props.isMobile;
  var paddingOpt = Props.padding;
  var gradientOpt = Props.gradient;
  var dataTestId = Props.dataTestId;
  var align = alignOpt !== undefined ? alignOpt : "top";
  var autoplay = autoplayOpt !== undefined ? autoplayOpt : false;
  var autoplayPaused = autoplayPausedOpt !== undefined ? autoplayPausedOpt : false;
  var position = positionOpt !== undefined ? positionOpt : "center";
  var size = sizeOpt !== undefined ? sizeOpt : "lg";
  var style = styleOpt !== undefined ? styleOpt : "line";
  var enableTruncation = enableTruncationOpt !== undefined ? enableTruncationOpt : false;
  var isMobile = isMobileOpt !== undefined ? isMobileOpt : false;
  var padding = paddingOpt !== undefined ? paddingOpt : true;
  var gradient = gradientOpt !== undefined ? gradientOpt : false;
  var truncateSize = isMobile ? 4 : 10;
  var truncateThreshold = isMobile ? 8 : 20;
  var enableTruncation$1 = enableTruncation && total >= truncateThreshold;
  var items = Belt_Array.range(0, total - 1 | 0);
  var autoplay$1 = autoplayPaused ? false : autoplay;
  var isWithinRange = function (i, offset) {
    var range = truncateSize + offset | 0;
    var leftRemainder = Math.max(range - index | 0, 0);
    var rightRemainder = Math.min((total - index | 0) - range | 0, 0);
    var diff = i - index | 0;
    if (diff < 0) {
      return diff >= (Math.imul(-1, range) + rightRemainder | 0);
    } else if (diff > 0) {
      return (diff - range | 0) < leftRemainder;
    } else {
      return true;
    }
  };
  var verticalPositionStyle = typeof align === "object" ? align.NAME === "arbTop" ? {
    top: CSS$Showside.intToPx(align.VAL)
  } : {
    bottom: CSS$Showside.intToPx(align.VAL)
  } : align === "top" ? {
    top: "0px"
  } : {
    bottom: "0px"
  };
  var items$1 = React.useMemo(function () {
    return Belt_Array.map(Belt_Array.keep(items, function (i) {
      if (isWithinRange(i, 6)) {
        return true;
      } else {
        return !enableTruncation$1;
      }
    }), function (i) {
      var size$1 = !isWithinRange(i, 3) && enableTruncation$1 ? "zero" : !isWithinRange(i, 0) && enableTruncation$1 ? "xs" : size;
      var itemPositionStyle;
      var exit = 0;
      exit = typeof align === "object" ? align.NAME === "arbTop" ? 1 : 2 : align === "top" ? 1 : 2;
      switch (exit) {
        case 1:
          itemPositionStyle = {
            top: "6px"
          };
          break;
        case 2:
          itemPositionStyle = {
            bottom: "6px"
          };
          break;
      }
      if (size$1 === undefined) {
        return null;
      }
      var sizeCn = size$1 === "zero" ? style === "circle" ? "w-0 h-0" : "w-0 h-1" : size$1 === "lg" ? style === "circle" ? "w-4 h-4" : "w-20 h-1" : size$1 === "sm" ? style === "circle" ? "w-2 h-2" : "w-10 h-1" : size$1 === "xs" ? style === "circle" ? "w-1 h-1" : "w-2 h-1" : style === "circle" ? "w-4 h-4" : "w-full h-1";
      var tmp;
      if (i === index) {
        var tmp$1 = {
          className: CSS$Showside.prefix(Cn.make(["absolute bg-white", sizeCn])),
          index: index,
          autoplay: autoplay$1,
          autoplayPaused: autoplayPaused
        };
        if (mediaId !== undefined) {
          tmp$1.mediaId = mediaId;
        }
        if (progress !== undefined) {
          tmp$1.progress = progress;
        }
        if (progressSpeed !== undefined) {
          tmp$1.progressSpeed = progressSpeed;
        }
        if (setProgressRef !== undefined) {
          tmp$1.setProgressRef = Caml_option.valFromOption(setProgressRef);
        }
        tmp = React.createElement(QuickViewTabs$ProgressBar, tmp$1);
      } else {
        tmp = i < index ? React.createElement("div", {
          className: CSS$Showside.prefix(Cn.make(["absolute bg-white transition-none duration-0 w-full", sizeCn]))
        }) : null;
      }
      return React.createElement(DataAttribute$Showside.make, {
        dataActive: i === index,
        dataTestId: "qv-tab-item",
        children: React.createElement("div", {
          className: CSS$Showside.prefix(Cn.make(["relative", "duration-200 transition-all", "no-touch-highlight", "pointer-events-auto", "no-flicker", size$1 !== "zero" ? "mr-1" : "mr-0", Belt_Option.isSome(onClick) ? "cursor-pointer" : "", sizeCn])),
          style: itemPositionStyle,
          onClick: function (param) {
            if (onClick !== undefined) {
              return Curry._1(onClick, i);
            }
          }
        }, React.createElement("div", {
          className: CSS$Showside.prefix("w-full h-8 absolute left-1/2 right-1/2 mt-2 transform -translate-x-1/2 -translate-y-1/2")
        }), React.createElement("div", {
          className: CSS$Showside.prefix(Cn.make(["absolute w-full rounded-full overflow-hidden", "bg-white", i === index ? "bg-opacity-60" : "bg-opacity-25", sizeCn])),
          style: itemPositionStyle
        }, tmp)),
        key: String(i)
      });
    });
  }, [[total, index, size], mediaId]);
  var renderGradient = function (param) {
    var verticalPositionCn = typeof align === "object" ? align.NAME === "arbTop" ? "top-0" : "bottom-0" : align === "top" ? "top-0" : "bottom-0";
    if (!gradient) {
      return null;
    }
    var tmp;
    if (typeof align === "object") {
      var variant = align.NAME;
      tmp = variant === "arbTop" || variant === "arbBottom" ? align.VAL : 0;
    } else {
      tmp = 0;
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute w-full left-0 pointer-events-none no-flicker", verticalPositionCn])),
      style: {
        background: typeof align === "object" ? align.NAME === "arbTop" ? "linear-gradient(rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 60%)" : "linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0) 80%)" : align === "top" ? "linear-gradient(rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 60%)" : "linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0) 80%)",
        height: CSS$Showside.intToPx(144 + tmp | 0)
      }
    });
  };
  var tmp = {
    children: React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-1 justify-center max-w-full")
    }, items$1)
  };
  if (dataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  return React.createElement(React.Fragment, undefined, renderGradient(undefined), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute right-0", "left-0", position === "right" ? padding ? "pr-3" : "" : size === "full" ? padding ? "px-6" : "" : isMobile ? padding ? "px-6" : "" : position === "center" && padding ? "px-32" : ""])),
    style: verticalPositionStyle
  }, React.createElement(DataAttribute$Showside.make, tmp)));
}
QuickViewTabs.displayName = "QuickViewTabs";
var make = React.memo(QuickViewTabs);
export { ProgressBar, make };
/* make Not a pure module */